import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3052c9fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "page-header-title" }
const _hoisted_4 = { class: "left" }

import {ref} from "vue";
import {ArrowLeftBold} from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
    isBack: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "",
    }
},
  emits: ["back"],
  setup(__props, { emit: __emit }) {



const emit = __emit;
const back = () => {
    emit("back");
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isBack)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "page-header-back",
            onClick: back
          }, [
            _createVNode(_component_el_icon, {
              size: "18px",
              style: {"margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeftBold))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(__props.isBack ? 'page-header-mark' : 'page-header-mark-widen')
      }, null, 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "right")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "left")
    ])
  ]))
}
}

})